export default "__VITE_ASSET__32cafd9e__"